module.exports = __webpack_public_path__ + "static/img/howto_pic.17c471d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/global_assets/images/home/howto_pic.png
// module id = 4BUH
// module chunks = 150